var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',{staticClass:"mb-2",attrs:{"x-small":"","color":"green white--text"},on:{"click":_vm.fetchDoc}},[_vm._v(" Libre deuda ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }